import $ from "jquery";

import 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';

import Navigation from './components/navigation';

import BannerVideoHandler from './components/banner-video';

import ArchiveFilterSelectHandler from './components/archive-filter-select';

import SponsorsSliderHandler from './components/sponsors-slider';

import * as GeneralFunctions from './components/general-functions';



// Execute functions / classes on document ready
$(document).ready( function () {
    new Navigation();
    new BannerVideoHandler();
    new ArchiveFilterSelectHandler();
});

// Execute functions / classes on document load
document.addEventListener("DOMContentLoaded", function() {
    GeneralFunctions.ScrollToPageSection();
    GeneralFunctions.scrollToId();
    GeneralFunctions.calcViewHeight();

    new SponsorsSliderHandler();
});

window.addEventListener('resize', () => {
    GeneralFunctions.calcViewHeight();
});